import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col, Image, Form } from "react-bootstrap";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { IMAGES } from "../assets/images/images";
import { Icon } from "@iconify/react";
import { useSelector } from "react-redux";
import {
  propertyTypesHomeFilter as getPropertyListing,
} from "../utility/apiServices/propertiesServices";
import { FilterContext } from "../utility/globle/providers/store/filterContext";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [filters, setFilters] = useState([])
  const { t, i18n } = useTranslation();
  const getPropertyTypes = async () => {
    try {
      const result = await getPropertyListing()
      if (result) {
        setFilters(result?.data?.results)
      }
    } catch (error) {
      console.log(error, 'Check the error while getting types')
    }
  }
  const { filterValues, setFilterValues, resetFilters } = useContext(FilterContext);
  const currentLanguage = i18n.language;
  const navigate = useNavigate();
  const handleItemClick = (index, value) => {
    // console.log(index , value , 'is cliked.')
    const selectedPropertyTypes = filterValues?.propertyType
    if (selectedPropertyTypes.includes(value)) {
      setFilterValues((prev) => ({
        ...prev,
        propertyType: selectedPropertyTypes.filter((type) => type !== value),
      }));

    } else {
      setFilterValues((prev) => ({
        ...prev,
        propertyType: [...selectedPropertyTypes, value],
      }));
    }
    navigate('/')
  };
  useEffect(() => {
    getPropertyTypes()
  }, [])

  return (
    <section className="footer">
      <Container fluid>
        <Row className="mb-lg-0 mb-4">
          <Col lg={12} md={12}>
            <div className="footLogoFlex">
              <Image src={IMAGES.WhiteLogo} alt="" />
              <div className="socialBox">
                <h4>{t("footer.follow_us")}</h4>
                <ul className="socialFlex">
                  <li>
                    <Link>
                      <Icon icon="ri:facebook-fill" fontSize={16} />
                    </Link>
                  </li>
                  <li>
                    <Link>
                      <Icon icon="akar-icons:linkedin-fill" fontSize={16} />
                    </Link>
                  </li>
                  <li>
                    <Link>
                      <Icon icon="pajamas:twitter" fontSize={16} />
                    </Link>
                  </li>
                  <li>
                    <Link>
                      <Icon icon="ri:instagram-fill" fontSize={16} />
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </Col>
        </Row>
        <div className="footerPadding">
          <Row>
            <Col lg={3} md={6} className="mb-lg-0 mb-4">
              <h3>{t("footer.contact_info.heading")}</h3>
              <ul>
                <li><Image src={IMAGES.Footicon1} alt="" /> {t("footer.contact_info.address")}</li>
                <li><Image src={IMAGES.Footicon2} alt="" /> 1-333-345-6868</li>
                <li><Image src={IMAGES.Footicon3} alt="" /> demo@gmail.com</li>
              </ul>
            </Col>
            <Col lg={3} md={6} xs={12} className="mb-lg-0 mb-4">
              <h3>{t("footer.useful_links.heading")}</h3>
              <ul>
                <li>
                  <Link>{t("footer.useful_links.home")}</Link>
                </li>
                <li>
                  <Link>{t("footer.useful_links.about_us")}</Link>
                </li>
                <li>
                  <Link>{t("footer.useful_links.list_your_property")}</Link>
                </li>
                <li>
                  <Link>{t("footer.useful_links.contact_us")}</Link>
                </li>
              </ul>
            </Col>
            <Col lg={3} md={6} xs={12} className="mb-lg-0 mb-4">
              <h3>{t("footer.categories.heading")}</h3>
              <ul>
                {filters && filters.length > 0 &&
                  filters.filter(val => val.property_count > 0).slice(0, 5).map((val, index) => (
                    <li
                      key={val.id}
                      style={{
                        color: filterValues?.propertyType.includes(val.id) ? 'red' : '',
                      }}
                      className="category-item"
                      onClick={() => { handleItemClick(index, val.id) }}
                    >
                      <Link>{currentLanguage === "he" ? val.title : val.eng_title}</Link>
                    </li>
                  ))}
              </ul>
            </Col>
            <Col lg={3} md={6} className="mb-lg-0 mb-4">
              <h3>{t("footer.newsletter.heading")}</h3>
              <p>{t("footer.newsletter.description")}</p>
              <Form.Group className="mailFooter">
                <Icon icon="carbon:email" fontSize={25} />
                <Form.Control
                  style={currentLanguage === "he" ? { marginRight: "0.7em" } : { marginLeft: "0.7em" }}
                  type="email"
                  placeholder={t("footer.newsletter.placeholder")}
                />

                <Icon icon="mynaui:send" className="cursor-pointer" fontSize={25} />
              </Form.Group>

            </Col>
          </Row>
        </div>
      </Container>
      <div className="copyright">
        <Container fluid>
          <Row>
            <Col>
              <div className="copyrightFlex">
                <p>{t("footer.copyright")}</p>
                <ul>
                  <li>
                    <Link>{t("footer.terms")}</Link>
                  </li>
                  <li>
                    <Link>{t("footer.privacy_policy")}</Link>
                  </li>
                </ul>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default Footer;
